import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ArrowUpRight, ArrowDownLeft } from "lucide-react";

export default function Messages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/messages?limit=100")
      .then(({ data }) => setItems(data))
      .catch((err) => { console.error("Failed to load messages:", err); })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8 md:p-12 max-w-[1400px]">
      <div className="mb-12">
        <div className="overline mb-3">— Message log</div>
        <h1 className="font-heading font-black text-4xl md:text-5xl tracking-tighter leading-none" data-testid="messages-title">Activity.</h1>
        <p className="mt-3 text-white/60">Every DM received and every automated reply sent.</p>
      </div>

      {loading ? (
        <div className="text-white/60">Loading…</div>
      ) : items.length === 0 ? (
        <div className="surface-card p-12 text-center" data-testid="messages-empty">
          <div className="font-heading font-black text-2xl tracking-tighter mb-2">Quiet on the wire.</div>
          <p className="text-white/60">Messages will appear here as soon as a follower DMs a matching keyword.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="messages-list">
          {items.map((m) => (
            <div key={m.id} className="surface-card p-5 flex items-start gap-4" data-testid={`message-${m.id}`}>
              <div className={`mt-1 w-8 h-8 flex items-center justify-center ${m.direction === "incoming" ? "bg-surface/5" : "bg-klein text-white"}`}>
                {m.direction === "incoming" ? <ArrowDownLeft className="w-4 h-4" /> : <ArrowUpRight className="w-4 h-4" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 text-xs mb-1">
                  <span className="overline">{m.direction === "incoming" ? "Received" : "Sent"}</span>
                  <span className="text-white/40">·</span>
                  <span className="font-mono text-white/60">{new Date(m.created_at).toLocaleString()}</span>
                </div>
                <div className="text-sm text-white whitespace-pre-wrap break-words">{m.text}</div>
                {m.matched_keyword_id && <div className="text-xs text-klein mt-1 font-mono">matched trigger</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
